<template>
	<div id="subscribe">
		<v-header :selectedItemVal="2"></v-header>
		<div class="main">
			<div class="subscribe">
				<div class="page_tag">
					<h2>
						首页 &nbsp;> &nbsp; 我的订阅
					</h2>
				</div>
				<div class="page_content">
					<div class="my_bull_class">
						<div class="class_part_tag">
							<h2>
								牛人课
							</h2>
						</div>
						<div class="class_part_content">
							<v-classList :bullClassData="bullClassList"></v-classList>
						</div>
					</div>
					<div class="my_playback">
						<div class="playback_part_tag">
							<h2>
								直播回放
							</h2>
						</div>
						<div class="playback_part_content">
							<v-classList :playbackData="playbackList"></v-classList>
						</div>
					</div>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
import vHeader from '../common/header'
	 
import vFooter from '../common/footer'
import vClassList from '../common/class_list'
import vPlayback from '../common/playback'
export default{
	name:"mySubscribe",
	data(){
		return {
			bullClassList:[],
			playbackList:[],
		}
	},
	components: {
	  'v-header': vHeader,
	  'v-footer':vFooter,
	  'v-classList':vClassList,
	  'v-playback': vPlayback
	},
	mounted() {
		this.getBullClassSubscribe();
		this.getSearchSubscribe();
	},
	methods:{
		//我的订阅（牛人课）
		getBullClassSubscribe(){
			//+------------------------构建请求参数--------------------
			let data = {
				
			};
			//+------------------------请求我的订阅数据---------------
			this.apiServer.mine.getBullClassSubscribe()
			.then(res => {
				if(res.data.code == 200){
					if(res.data.data.businessCode != 10){
						this.$message.error(res.data.data.businessMessage);
						return false;
					}
					
					//更新牛人课数据
					this.bullClassList = res.data.data.videos;
				}
			})
			.catch(error => {
				console.log('获取我的订阅异常',error);
			})
		},
		//我的订阅（App商城）
		getSearchSubscribe(){
			//+-------------------构建请求参数---------------------
			let data = {
				pageNow:'',
				pageSize:''
			};
			//+-------------------请求订阅数据---------------------
			this.apiServer.mine.getSearchSubscribe(data)
			.then(res => {
				if(res.data.code == 200){
					if(res.data.data.businessCode != 10){
						this.$message('暂无订阅');
						return false;
					}
					
					//更新数据
					this.playbackList = res.data.data.appSubscribeResponseVOS;
				}
			})
			.catch(error => {
				console.log('获取直播订阅异常',error);
			});
		},
	}
}
</script>

<style>
	
	.subscribe{
		width: 1180px;
		margin: 0 auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/user/mySubscribe.vue